import { isMicrosoftSSOUser } from "../../constants/sso";

type OnboardingAccount = {
  groups?: readonly string[] | null;
};

/**
 * Account/session-level exclusions from automatic CIP onboarding.
 *
 * Microsoft SSO is a temporary fallback because those users are currently
 * exposed to the frontend as `cip_users` rather than `home_health_external`.
 * Deliberately do not inspect the selected clinic: changing facilities must not
 * change whether an account owes onboarding.
 */
export const isOnboardingExcludedAccount = (
  user?: OnboardingAccount | null
): boolean =>
  (user?.groups?.includes("home_health_external") ?? false) ||
  isMicrosoftSSOUser();
